<template>
  <div>
      <DefaultButton v-show="resourceId > 0" component="a" :href="'/nova/form-generator/?id=' + resourceId">
          Im VueForm-Builder bearbeiten
      </DefaultButton>
  </div>
</template>

<script>

export default {
  props: ['resourceName', 'resourceId', 'panel'],

  mounted() {

  },
}
</script>
